/* eslint-disable @typescript-eslint/ban-types */
import { UserDtoToUser } from '../../mappers/auth';
import { removesSpecialCharacters } from '../../utils/formaters';
import { api } from './api';
export const AuthApi = api.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: ({ username, password }) => ({
                url: 'api/LoginPdc',
                method: 'post',
                data: { usuario: removesSpecialCharacters(username), senha: password },
            }),
            transformResponse: (response) => UserDtoToUser(response),
        }),
        setBase: builder.mutation({
            query: data => ({
                url: 'api/UsuarioPdc/AlterarBase',
                method: 'post',
                data: {
                    grupoId: data.group,
                    divisoes: [...data.divisions],
                },
            }),
        }),
        forgotPassword: builder.mutation({
            query: data => ({
                url: 'api/LoginPdc/EsqueciSenha',
                method: 'post',
                data: {
                    cpf: removesSpecialCharacters(data.cpf),
                    email: data.email,
                    dataNascimento: data.birthdate.split('/').reverse().join('-'),
                },
            }),
        }),
        resetPassword: builder.mutation({
            query: data => ({
                url: 'api/LoginPdc/AlterarSenha',
                method: 'post',
                data: {
                    cpf: removesSpecialCharacters(data.username),
                    senha: data.pwd,
                    novaSenha: data.newPwd,
                },
            }),
            transformResponse: (response) => UserDtoToUser(response),
        }),
        setColor: builder.mutation({
            query: color => ({
                url: 'api/UsuarioPdc/Cor',
                method: 'post',
                data: { cor: color },
            }),
        }),
        setEnterprise: builder.mutation({
            query: title => ({
                url: 'api/UsuarioPdc/Titulo',
                method: 'post',
                data: { titulo: title },
            }),
        }),
        setLogo: builder.mutation({
            query: formData => ({
                url: 'api/UsuarioPdc/Logo',
                method: 'post',
                data: formData,
                formData: true,
            }),
        }),
        setSections: builder.mutation({
            query: data => ({
                url: 'api/UsuarioPdc/Dashboard',
                method: 'post',
                data: {
                    sections: data,
                },
            }),
        }),
        setStep: builder.mutation({
            query: step => ({
                url: 'api/UsuarioPdc/EtapaOnboarding',
                method: 'post',
                data: {
                    etapaOnboarding: step,
                },
            }),
        }),
    }),
});
export const { useSetColorMutation, useSetEnterpriseMutation, useSetLogoMutation, useSetSectionsMutation, useLoginMutation, useSetBaseMutation, useForgotPasswordMutation, useResetPasswordMutation, useSetStepMutation, } = AuthApi;
